<p class="terms-and-conditions">
  By signing up, you agree to our <a type="button" class="link fw-bold" (click)="openTermsPrivacyDialog()">Terms and
  Conditions</a>
</p>
